import React from 'react';
import { Link } from 'react-router-dom';

import styles from '../styles/TopHeaderLayout.module.css';

export default function TermsOfUse() {
    return (
        <div className={styles.main}>
            <div className={styles.headline}>
                <h1>Условия использования Личного кабинета Союза «СОАУ Альянс»</h1>
            </div>
            <h2>1. Общие положения</h2>
            <a>1.1. Настоящие Условия использования (далее — «Условия») определяют порядок доступа и работы в Программе.</a>
            <a>1.2. Программа является закрытой системой, предназначенной для юридического сопровождения арбитражных дел арбитражных управляющих и контроля со стороны СОАУ.</a>
            <a>1.3. Доступ к Программе предоставляется только проверенным лицам по решению СОАУ.</a>

            <h2>2. Права и обязанности Пользователя</h2>
            <a>2.1. Пользователь обязуется:</a>
            <ul>
            <li>использовать Программу только для законных целей;</li>

            <li>не передавать логин и пароль третьим лицам;</li>

            <li>соблюдать внутренние регламенты СОАУ.</li>
            </ul>
            <a>2.2. Пользователь имеет право:</a>
            <ul>
            <li>использовать Программу в рамках предоставленного функционала;</li>

            <li>получать техническую поддержку.</li>
            </ul>
            <h2>3. Ограничения</h2>
            <a>3.1. Запрещается:</a>
            <ul>
            <li>пытаться изменить код Программы;</li>

            <li>вмешиваться в работу серверов;</li>

            <li>Использование Программы исключительно в рамках полномочий и задач, установленных СОАУ. Запрещено использование Программы для любых иных коммерческих целей без письменного согласия СОАУ.</li>
            </ul>
            <h2>4. Внутренний баланс</h2>
            <a>4.1. Внутренний баланс отображает условные единицы.</a>
            <a>4.2. Условные единицы не являются денежными средствами и не подлежат возврату или обмену.</a>

            <h2>5. Ответственность</h2>
            <a>5.1. Программа предоставляется «как есть».</a>
            <a>5.2. Владелец не несёт ответственности за:</a>
            <ul>
            <li>действия Пользователя, приведшие к утечке данных;</li>

            <li>перебои в связи;</li>

            <li>последствия, вызванные действиями третьих лиц.</li>
            </ul>
            <h2>6. Удаление учётной записи</h2>
            <a>6.1. Полное удаление учётной записи невозможно — сохраняются данные, обязательные по закону.</a>
            <a>6.2. Возможна деактивация с ограничением доступа.</a>

            <h2>7. Ответственность пользователя за предоставленные персональные данные</h2>
            <a>7.1 Законность предоставления данных</a>
            <ul>
            <li>все переданные в Программу персональные данные третьих лиц получены и обрабатываются им на законных основаниях, в том числе на основании надлежаще оформленных согласий субъектов персональных данных;</li>

            <li>содержание и форма согласий соответствуют требованиям Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных» и иного применимого законодательства.</li>
            </ul>
            <a>7.2 Предоставление согласий и документов</a>
            <a>Пользователь обязуется по требованию СОАУ или владельца Программы:</a>
            <ul>
            <li>предоставить оригиналы согласий на бумажном носителе либо их надлежащим образом заверенные копии;</li>

            <li>предоставить подтверждающие документы, удостоверяющие личность подписанта согласия, а также иные документы, необходимые для подтверждения законности обработки персональных данных.</li>
            </ul>
            <a>7.3 Проверка подлинности документов</a>
            <a>СОАУ и владелец Программы осуществляют проверку документов пользователей в пределах своих полномочий и обязанностей, установленных законодательством. Проверка согласий на обработку персональных данных и иных документов, загруженных пользователем в Программу, может проводиться как в рамках обязательных процедур, так и выборочно по усмотрению СОАУ или владельца Программы.</a>
            <a>При выявлении признаков недостоверности либо подделки документов владелец Программы вправе:</a>
            <ul>
            <li>приостановить или ограничить доступ пользователя к Программе;</li>

            <li>передать соответствующую информацию в компетентные государственные органы.</li>
            </ul>

            <a>7.4 Ответственность</a>
            <a>Пользователь несёт полную самостоятельную ответственность за законность и достоверность предоставленных персональных данных и согласий.</a>
            <a>СОАУ и владелец Программы освобождаются от ответственности за любые последствия, вызванные:</a>
            <ul>
            <li>предоставлением пользователем поддельного или недействительного согласия;</li>

            <li>отсутствием согласия у пользователя на обработку данных третьих лиц.</li>
            </ul>
            <a>7.5 Фиксация факта загрузки</a>
            <a>Факт загрузки согласия в Программу фиксируется с сохранением даты и времени загрузки, IP-адреса, идентификатора пользователя и контрольной суммы файла. Эти данные могут быть использованы в качестве доказательств при разрешении споров.</a>

            <h2>8. Разрешение споров</h2>
            <a>8.1. Все споры решаются сначала в порядке досудебного урегулирования через СОАУ.</a>
            {/* <a>8.2. Если спор не урегулирован, он подлежит рассмотрению в суде РФ по месту нахождения СОАУ.</a> */}

            <h2>9. Заключительные положения</h2>
            <a>9.1. Владелец вправе изменять Условия в одностороннем порядке.</a>
            <a>9.2. Использование Программы после внесения изменений означает согласие с ними.</a>
        </div>
    )
}